import * as React from "react";
const SvgBin24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 18,
        fill: "black",
        viewBox: "0 0 24 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1 0H0v18h24V0h-7v3H7V0H1Zm1 16V2h3v3h14V2h3v14H2Zm14-9v7h2V7h-2ZM6 14V7h2v7H6Zm5-7v7h2V7h-2Z",
      clipRule: "evenodd"
    })
  );
export default SvgBin24Px;
